import { css } from 'linaria';
import React from 'react';
import { cn } from './classnames';

export type AdaptivityProps = {
	/**
	 * Контент будет отрендерен, в процессе SSR
	 */
	ssrFallback?: React.ReactNode;
	/**
	 * Контент, который будет отрендерен, если на текущем брейкпойнте компонент рендериться не должен
	 */
	fallback?: React.ReactNode;
};

type WithAdaptiveOptions = {
	displayName?: string;
	ssrClassName?: string;
};

const adaptiveComponentSSR = css`
	display: contents;
`;

export const createAdaptiveComponent = ({ displayName, ssrClassName }: WithAdaptiveOptions) => {
	const AdaptiveComponent = ({ children }: { children: React.ReactNode }) => (
		<div className={cn(ssrClassName, adaptiveComponentSSR)}>{children}</div>
	);

	if (process.env.NODE_ENV !== 'production') {
		AdaptiveComponent.displayName = displayName;
	}

	return AdaptiveComponent;
};
